module.exports = __webpack_public_path__ + "static/media/F_FI_19-07-18_Natpar.1f0eddf8.pdf";